var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"items":_vm.items,"item-text":_vm.text,"item-value":_vm.value,"outlined":"","filled":"","dense":"","clearable":"","label":"Seleccione un usuario","no-data-text":"No hay usuarios"},on:{"change":e => _vm.onChange(e)}})
}
var staticRenderFns = []

export { render, staticRenderFns }